export const colours = {
  white: "#FFFFFF",

  //zlto
  zltoYellow: '#FDBE1C',
  zltoDarkBlue: '#010323',
  zltoDarkBlueSecondary: '#061D42',
  zltoLightBlue: '#22A7F0',
  zltoLightBlueFaded: '#E8F6FE',
  zltoGrey: '#E6E6E9',
  zltoGreyBackground: '#F3F6FA',
  zltoGreen: '#44B749',

  // bright red
  primary: "#FE4D57",
  primaryTinted: "#FFEDEE",

  // purple
  secondaryLight: "#5E63BF",
  secondaryLightTinted: "rgba(94, 99, 191, 0.15)",

  // orange
  tertiary: "#F9AB3E",

  darkBlue: "#0E1944",
  lightBlue: "#50CAF1",
  lightBlueTinted: "#E5F7FD",

  darkGreen: "#15AF92",
  darkGreenTinted: "#E9F4F2",
  backgroundGreen: "#028169",

  greyMid: "#B8BDD0",
  grey2: "#878CA1",
  grey3: "#CED2E3",
  grey4: "#F3F6FA",
  // inner page background
  grey5: "#f7f7f7",

  // used on coloured cards
  chablis: "#FFEDE2",
};

export default colours;
